module.exports = __webpack_public_path__ + "static/media/saha.6f988daa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/saha.jpeg
// module id = 295
// module chunks = 0